<template>
  <div>
    <div class="row">
      <div class="col-6">
        <form v-on:submit.prevent="GetDataSearch" class="form">
          <label for="email">Filter businesses.</label>
          <input
            type="text"
            class="input"
            placeholder="Email, Name, MKit, FKit..."
            v-model="search"
          />
        </form>
      </div>
      <div class="col-5">
        <table>
          <tbody>
            <tr>
              <td>
                <input type="radio" value="Active" v-model="selectionmade" @change="resetPaginationAndFetch"/>Active
              </td>
              <td>
                <input type="radio" value="Archived" v-model="selectionmade" @change="resetPaginationAndFetch"/>Archived
              </td>
              <td>
                <input type="radio" value="Inactive" v-model="selectionmade" @change="resetPaginationAndFetch"/>Inactive
              </td>
              <td>
              <input type="radio" value="SpecialAttention" v-model="selectionmade" @change="resetPaginationAndFetch"/>Special Attention
            </td>
            <td>
              <input type="radio" value="Subscription" v-model="selectionmade" @change="resetPaginationAndFetch"/>Subscription
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        <router-link
          class="btn btn-green float-right"
          to="/Admin/Businesses/New"
          ><i class="icon icon-pen"></i> Register Business</router-link
        >
      </div>
      <div class="col-12">
        <table>
          <thead>
            <tr>
              <td
                v-for="column in columns"
                :key="column.name"
                @click="column.sortable === true ? sortBy(column.name) : ''"
                :class="
                  sortKey === column.name
                    ? sortOrders[column.name] > 0
                      ? 'headerSortUp'
                      : 'headerSortDown'
                    : ''
                "
                :style="'width:' + column.width + ';' + 'cursor:pointer;'"
              >
                {{ column.label }}
              </td>
              <td><i class="icon icon-cogs"></i></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in tblrows" :key="row.id">
              <td>{{ row.id }}</td>
              <td>{{ row.name }}</td>
              <td>{{ row.contact_email }}</td>
              <td>
                <span v-if="subscriptionTestsParts(row)" class="tests-cell">
                  <span
                    v-for="part in subscriptionTestsParts(row)"
                    :key="part"
                    >{{ part }}</span
                  >
                </span>
                <template v-else>{{ legacyTestsLabel(row) }}</template>
              </td>
              <td>
                <router-link
                  :to="{
                    name: 'Admin_Businesses_Modify',
                    params: { id: row.id },
                  }"
                  class="btn btn-orange"
                  >Modify</router-link
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="col-6">
        Displaying {{ count }} of {{ total_filter }}. Total of {{ total }} rows.
      </div>
      <div class="col-6">
        <div class="btn-group float-right">
          <div class="btn btn-green" v-on:click="GetDataPrev">
            &larr; PREVIOUS
          </div>
          <div class="btn btn-green" v-on:click="GetDataNext">NEXT &rarr;</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "vuex";
export default {
  name: "Admin_Businesses_ListDatatable",
  setup() {
    const store = useStore();

    return { store };
  },
  data() {
    let sortOrders = {};
    let columns = [
      { width: "auto", label: "ID", name: "id", sortable: true },
      { width: "auto", label: "Name", name: "name", sortable: true },
      {
        width: "auto",
        label: "Contact Email",
        name: "contact_email",
        sortable: true,
      },
      {
        width: "auto",
        label: "Available Tests",
        name: "credits",
        sortable: true,
      },
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      selectionmade:"Active",
      tblrows: [],
      count: 0,
      order: [0, "DESC"],
      search: "",
      offset: 0,
      total: 0,
      limit: 20,
      total_filter: 0,
      next: 0,
      prev: 0,
      columns: columns,
      sortKey: "id",
      sortOrders: sortOrders,
    };
  },
  methods: {
    GetData() {
      let body = {
        search: this.search,
        order: this.order,
        limit: this.limit,
        offset: this.offset,
      };
      
      // Choose the filter param based on the selected radio.
      // SpecialAttention and Subscription are cross-cutting flags (not a status),
      // so they send their own param and the backend does the filtering.
      if (this.selectionmade === "SpecialAttention") {
        body.special_attention = true;
      } else if (this.selectionmade === "Subscription") {
        body.onboarding_policy = "monthly_subscription";
      } else {
        body.status = this.selectionmade;
      }

      this.store
        .dispatch("Admin/GetBusinessesDatatable", body)
        .then((result) => {
          this.total = result.total;
          this.total_filter = result.total_filter;
          // logic to only show the active businesses goes here....

          // this.tblrows = result.data;
          // Skip client-side filtering for cross-cutting filters - backend handles them
          this.tblrows =
            this.selectionmade === "SpecialAttention" ||
            this.selectionmade === "Subscription"
              ? result.data
              : this.filterByFiniteCredits(result.data, this.selectionmade);
          this.count = this.offset + this.tblrows.length;
          this.prev =
            this.offset - this.limit < 0 ? 0 : this.offset - this.limit;
          this.next =
            this.offset + this.tblrows.length > this.total_filter
              ? this.total_filter
              : this.offset + this.tblrows.length;
        })
        .catch((err) => {
          console.log(err);
          this.total = 0;
          this.total_filter = 0;
          this.tblrows = [];
          this.count = 0;
          this.prev = 0;
          this.next = 0;
        });
    },
    GetDataSearch() {
      this.tblrows = [];
      this.offset = 0;

      this.GetData();
    },
    GetDataNext() {
      if (this.next != this.total_filter) {
        console.log(this.next);
        this.offset = this.next;
        this.GetData();
      }
    },
    GetDataPrev() {
      if (this.offset !== 0) {
        this.offset = this.prev;
        this.GetData();
      }
    },
    resetPaginationAndFetch() {
      this.offset = 0; // Reset offset to 0
      this.GetData();
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] == value);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      let name = this.getIndex(this.columns, "name", key);
      let dir = this.sortOrders[key] > 0 ? "ASC" : "DESC";
      this.order = [name, dir];

      this.GetData();
    },
    filterByFiniteCredits(data,selectionmade) {
  return data.filter(item => item.status === selectionmade);
},
    // Subscription businesses have no single credits value, so the cell shows usage
    // instead. Returned as segments rather than one string so they can sit on one
    // line on wide screens and stack on narrow ones. Null for legacy businesses.
    subscriptionTestsParts(row) {
      const billing = row.billing;
      if (!billing || billing.onboardingPolicy !== "monthly_subscription") {
        return null;
      }
      const usage = billing.subscriptionUsage;
      // subscriptionUsage can be null (e.g. pending checkout) - show the mode only.
      if (!usage) {
        return ["Subscription"];
      }
      const parts = [
        "Subscription",
        `${usage.includedUsed}/${usage.includedTests} used`,
      ];
      if (usage.overageTests > 0) {
        parts.push(`+${usage.overageTests} over`);
      }
      return parts;
    },
    legacyTestsLabel(row) {
      return row.infinite_credits == true ? "Infinite Credits" : row.credits;
    },
  },
  mounted() {
    this.GetData();
  },
};
</script>
<style scoped>
.tests-cell > span + span {
  margin-left: 0.35em;
}

.tests-cell > span + span::before {
  content: "· ";
  color: #8a8a8a;
}

@media only screen and (max-width: 720px) {
  .tests-cell > span {
    display: block;
  }

  .tests-cell > span + span {
    margin-left: 0;
  }
}
</style>
